import React, { useState } from "react";
import Salary from "..";
import DatePicker from "react-datepicker";
import { useNavigate, useSearchParams } from "react-router-dom";
import SelectSearch from "react-select-search";
import useReadWithGet from "../../../hooks/read/useReadWithGetMethod";
import { Modal } from "@mui/material";
import ReportUpload from "./ReportUpload";
import Pagination from "../../../components/pagination";
import PrimaryLoader from "../../../components/common/PrimaryLoader";
import { Button } from "../../../components/ui";
import RoundedContainer from "../../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../../components/table/Table";

const AdvanceAndBonus = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  let initialData = {
    month_year: searchParams.get("month_year")
      ? new Date(searchParams.get("month_year"))
      : new Date(),
    prev_month_year: new Date(),
    page_number: searchParams.get("page_number") || 0,
    limit: searchParams.get("limit") || 50,
    search_query: searchParams.get("search_query") || "",
    department_id: searchParams.get("department_id") || "",
    type: "advance",
  };

  const [departOption, setDepartOption] = useState([]);
  useReadWithGet({
    url: "department_listing",
    method: "GET",
    initialData: { limit: 50, searchQuery: "" },
    onSuccess: (res) => {
      let data = res.data.map(({ id, name }) => ({ value: id, name: name }));
      setDepartOption(data);
    },
  });
  const {
    list: advanceList,
    paramsObject,
    setGetListParams,
  } = useReadWithGet({
    url: "getMemberSalaryListing",
    initialData: initialData,
  });

  const [openUploadModal, setOpenUploadModal] = useState(false);
  const handleSearch = (e) => {
    let value = e.target.value;
    let data = {
      ...paramsObject,
      search_query: value,
      page_number: 0,
    };
    setGetListParams(data);
    setSearchParams(data);
  };
  const handleDate = (value, name) => {
    let data = {
      ...paramsObject,
      month_year: value,
    };
    setGetListParams(data);
    setSearchParams(data);
  };
  const handleChangeDepartment = (val) => {
    let data = {
      ...paramsObject,
      department_id: val,
      page_number: 0,
    };
    setGetListParams(data);
    setSearchParams(data);
  };

  const handleUploadData = () => {
    setOpenUploadModal(true);
  };
  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      page_number: val.selected,
    };
    setGetListParams(data);
    setSearchParams(data);
  };
  return (
    <Salary>
      {advanceList.isLoading && (
        <div className="w-full h-full fixed top-0 left-0 flex items-center justify-center bg-[#ffffffbf] z-50">
          <PrimaryLoader />
        </div>
      )}
      <div className=" mt-14 mb-20">
        <div className="">
          <form className="flex items-end justify-between px-5">
            <div className="flex items-end space-x-4">
              <div>
                <input
                  type="text"
                  placeholder="Search By Name..."
                  name="search_query"
                  className="input"
                  onChange={handleSearch}
                />
              </div>
              <div className="min-w-[10rem]  basis-[35%]">
                <label className=" roboto label">Select Month/Year</label>
                <DatePicker
                  required
                  name="month_year"
                  autoComplete="false"
                  className="input"
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  selected={paramsObject?.month_year}
                  onChange={(value) => handleDate(value, "month_year")}
                />
              </div>
              <div className="">
                <label htmlFor="salary" className="label">
                  Select Department:
                </label>
                <SelectSearch
                  onChange={handleChangeDepartment}
                  search
                  options={departOption}
                  value={paramsObject.department}
                  name="department"
                  placeholder="Select department"
                />
              </div>
            </div>
            <div className="px-4">
              <div className="flex space-x-4 items-end justify-between">
                {/* {salaryList?.length > 0 &&
                <div className=''>
                    <Button type='button' onClick={handleDownloadReport} className="">Download Report</Button>
                </div>} */}
                <div className="">
                  <Button type="button" onClick={handleUploadData} className="">
                    Upload Data
                  </Button>
                </div>
                <div className="">
                  {/* <button type='button' onClick={handleDownloadReport} className=" bg-[color:var(--color1)] text-white rounded px-4 py-2">Download Report</button> */}
                  <a
                    href="https://media-hr.payalsinghal.net/advance.xlsx"
                    className=" bg-[color:var(--color1)] text-white rounded px-4 py-2 block"
                    download
                  >
                    Download Report
                  </a>
                </div>
              </div>
            </div>
          </form>
          {advanceList?.data?.data?.length <= 0 ? (
            <p className=" text-center font-semibold text-lg my-5">
              No Data Found
            </p>
          ) : (
            <>
              <RoundedContainer className="mx-5">
                <div className="max-w-full overflow-x-auto">
                  <Table className="table-auto w-full">
                    <TableHead>
                      <TableHeaderCell className="w-[10%] text-center">
                        Sr.No
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[35%]">
                        Name
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[30%]">
                        Department
                      </TableHeaderCell>
                      <TableHeaderCell className="w-[25%] text-center">
                        Amount
                      </TableHeaderCell>
                    </TableHead>
                    <TableBody>
                      {advanceList?.data?.data?.map((data, idx) => {
                        const { employee_name, department_name, id, amount } = data;
                        return (
                          <TableRow key={idx}>
                            <TableCell className="text-center text-dark font-medium text-sm">
                              {paramsObject.limit *
                                (parseInt(paramsObject.page_number) + 1) -
                                (paramsObject.limit - (idx + 1))}
                            </TableCell>
                            <TableCell className="text-dark font-medium text-sm">
                              {employee_name}
                            </TableCell>
                            <TableCell className="text-dark font-medium text-sm capitalize">
                              {department_name || "---"}
                            </TableCell>
                            <TableCell className="text-center text-dark font-medium text-sm capitalize">
                              {amount || "---"}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </RoundedContainer>
              <RoundedContainer className="mx-5 mt-4">
                <Pagination
                  currentPage={+paramsObject.page_number}
                  lengthofItems={advanceList?.data?.total_count}
                  limit={paramsObject.limit}
                  onPageChange={handlePageClick}
                />
              </RoundedContainer>
            </>
          )}
        </div>
      </div>
      <Modal
        open={openUploadModal}
        onClose={() => setOpenUploadModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ReportUpload
          departOption={departOption}
          onClose={() => setOpenUploadModal(false)}
        />
      </Modal>
    </Salary>
  );
};

export default AdvanceAndBonus;
